const CONSTANTS = require('frontend-controller/lib/constants')

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		usage: 'management',
		resourceConnected: false,
	},

	model: {
		forwardFilterChanges: false,
		forceViewChange: false,
	},

	events: {
		refresh: {
			type: 'click',
			selector: 'button[data-field-type="refresh"]',
			action: function(event){
				event.preventDefault()
				event.stopImmediatePropagation()

				if(event.data.component.model.entityTable){
					event.data.component.model.entityTable.refreshData()
				}
			}
		}
	},

	methods: {
		/**
		 * will be called right before sanitizeForm() is done
		 */
		onBeforeSanitizeForm(storage){
			const fields = this.model.fields = this.model.fields || []
			fields.push({
				atom: {
					dataType: 'boolean',
					renderType: 'none',
				},
				config: {
					strict: true,
				},
				fieldCode: 'showSelectionOnly',
				lang: translationManager.mapLanguages(__ => Object.fromEntries(CONSTANTS.TRLS.KEYS.MODEL_FIELDS.map(key => [key, __(`ninja.filters.fields.showSelectionOnly.${key}`)]))),
			})

			this.model.showSelectedOnlyField = fields[fields.length - 1]
		},

		prepare(storage, isServer){
			const fieldConfig = this.getResourceRegisterContent('pickerFieldConfig') || {}
			const presetFilterParams = fieldConfig.presetFilterParams || {}

			// within pickers ninja filter forms have to show the "showSelectionOnly" boolean toggle
			if(fieldConfig.entityType){
				// the default value is determined by the presetFilterParams (which button within the ninjaPickerButton was pressed by the user?)
				this.model.showSelectedOnlyField.atom.renderType = 'toggle'
				if(presetFilterParams.showSelectionOnly){
					this.model.showSelectedOnlyField.config.default = 1
				}
			}
		},

		onChange: function(isRelationChange, changeDone, fieldData){
			if(this.model.forwardFilterChanges && this.model.entityTable){
				const data = (this.model.dirtyFields || {}).data || {}
				const attributes = data.attributes || {}

				this.model.entityTable.onFilterChanged(
					attributes,
					isRelationChange ? !(fieldData || {}).isLastRelationElement : false,
					isRelationChange ? (fieldData || {}).isLastRelationElement : false
				)
			}
		},
		submit: function(){},
	},

	hooks: {
		_attach: function($element, options){
			if(!this.model.controller){
				this.closest('templates_ninja_controller', controller => {
					this.model.controller = controller
				}, true)
			}
			if(!this.model.entityTable && this.model.controller){
				this.model.controller.find('templates_ninja_table_table', table => {
					if(!(table.config || {}).isSelectionTarget){
						this.model.entityTable = table
					}
				})
			}

			this.model.forwardFilterChanges = true
			if(this.config.usage === 'selection' || Object.keys(((this.model.dirtyFields || {}).data || {}).attributes || {}).length > 0){
				this.model.forceViewChange = true
				this.onChange()
				this.model.forceViewChange = false
			}
		},

		colTagsBubbleSelected: function($element, options){
			options = options || {}

			if(!this.model.tagPickerButtonComponent){
				this.model.tagPickerButtonComponent = getComponent($element.find('.fieldOf_tags > .base_form_fields_tag-picker-button'), true)
			}
			if(this.model.tagPickerButtonComponent){
				this.model.tagPickerButtonComponent.tagToggle(options.categoryID, options.categoryDataID)
			}
		}
	}
}
